import Base from "./base";

export default class Payco extends Base {
	makeExternalPayment(newStep) {
		this.props.externalFunc.depositFixturka(
			{
				amount: parseInt(this.state.stake),
				//fullName: this.getFullName(),
				//language: this.getActiveLanguageCode(),
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}

	makeExternalPaymentWithBonus(newStep, bonusId) {
		//const { selectedDeposit } = this.props;
		this.props.externalFunc.depositFixturka(
			{
				amount: parseInt(this.state.stake),
				//fullName: this.getFullName(),
				//language: this.getActiveLanguageCode(),
				claimsBonus: true,
				bonusId: bonusId,
			},
			(data) => {
				this.setState({
					externalUrl: data.payment_url,
					currentStep: newStep,
				});
			}
		);
	}
}
